<template>
    <div style="padding-bottom: 40px">
        <M3Warn v-if="data && data.m3_project && data.m3_project.duplicate_sections && data.m3_project.duplicate_sections.includes('financial_request')" type="yellow" :text="'Această secțiune a fost duplicată din proiectul companiei ' + getCompanyName(data.m3_project.duplicate_company_id)"></M3Warn>
        <CFTitle title="15. Descrierea investiției"></CFTitle>
        <M3Warn type="yellow" text="Se corelează cu cap. Activități previzionate al cererii de finanțare. <br>Se face o descriere generala a proiectului, a activităților/sub-activităților si legătura lor cu rezultatele așteptate din proiect."></M3Warn>
        <validation-observer #default="{ invalid }" ref="responsabilProiect">
            <span class="display-none">{{ invalid }}</span>
            <div>
                <p class="subtitle">Descrierea investiției</p>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                    <CFTextarea v-model="form.descriere" :read-only="completed" :limit="1000"></CFTextarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
            <p class="subtitle">Descrierea activităților:</p>
            <M3Warn type="red-warn" text="Activitățile pot fi adăugate din pagina "><template v-slot:link><router-link to="/aplicatii/m3-sketch/activitati" style="margin-left: 10px; color: #ffffff; font-weight: 600">Activități</router-link></template></M3Warn>
            <div v-for="activity in activities" :key="activity.name" style="margin-top: 10px">
                <p class="subtitle">ACTIVITATEA {{ activity.number }} - {{ activity.title }}</p>
                <validation-provider
                    #default="{ errors }"
                    rules="required"
                >
                    <CFTextarea v-model="form.activities[activity.number]" :read-only="completed" :limit="1000"></CFTextarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </div>
            <b-form-checkbox
                v-model="completed"
                switch
                size="lg"
                class="switch-box"
                style="margin-bottom: -40px;"
                @change="sendForm()"
            >Informațiile sunt complete și corecte</b-form-checkbox>
        </validation-observer>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import CFTextarea from "./CFTextarea";
    import { BFormCheckbox } from "bootstrap-vue";
    import M3Warn from "../M3Warn";
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';

    export default {
        name: "CFDescriereaInvestitiei",
        components: {
            CFTextarea,
            BFormCheckbox,
            CFTitle,
            M3Warn,
            ValidationProvider,
            ValidationObserver,
        },
        props:{
            data: {
                type: Object,
                default: null
            },
            m3GrantApplication: {
                type: Object,
                default: null
            },
        },
        data() {
            return {
                form: {
                    descriere: '',
                    activities: [],
                },
                completed: null,
                activities: []
            }
        },
        computed: {
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
            isCompleted() {
                return this.$store.getters['finantare/progress'].includes('Descrierea investitiei');
            },
        },
        watch: {
            isCompleted: {
                handler() {
                    this.completed = this.isCompleted;
                },
                deep: true,
                immediate: true
            },
            m3GrantApplication: {
                handler () {
                    if(this.m3GrantApplication && this.m3GrantApplication.descrierea_investitiei){
                        this.form.descriere = this.m3GrantApplication.descrierea_investitiei.descriere
                        this.m3GrantApplication.descrierea_investitiei.activities.forEach((activity, index) => {
                            this.form.activities[index] = activity;
                        })
                    }
                },
                deep: true
            },
            data: {
                handler () {
                    if(this.data && this.data.m3_project && this.data.m3_project.activities)
                        this.activities = this.data.m3_project.activities.activities;
                },
                deep: true
            },
        },
        mounted() {
            if(this.data && this.data.m3_project && this.data.m3_project.activities)
                this.activities = this.data.m3_project.activities.activities;

            if(this.m3GrantApplication && this.m3GrantApplication.descrierea_investitiei){
                this.form.descriere = this.m3GrantApplication.descrierea_investitiei.descriere
                this.m3GrantApplication.descrierea_investitiei.activities.forEach((activity, index) => {
                    this.form.activities[index] = activity;
                })
            }
            else{
                this.initialize();
                this.form.descriere = 'Investitia vizata prin proiectul propus, presupune ….'
            }
        },
        methods: {
            getCompanyName(id){
                let name = '';
                this.companies.forEach(company => {
                    if(Number(company.id) === Number(id))
                        name = company.name
                })

                return name;
            },
            sendForm(){
                if(this.completed){
                    this.$refs.responsabilProiect.validate().then((e) => {
                        if (!e) {
                            this.completed = false
                            this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        } else {
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {descrierea_investitiei: this.form})
                                .then( () => {
                                    this.$store.dispatch('finantare/addToProgress', 'Descrierea investitiei')
                                    this.$toast.success('Informațiile au fost salvate!')
                                    this.$emit('savedData')
                                })
                        }
                    })
                }
                else{
                    this.$store.dispatch('finantare/removeFromProgress', 'Descrierea investitiei')
                }
            },
            initialize(){
                this.activities.forEach(activity => {
                    this.form.activities[activity.number] = 'SUBACTIVITĂȚI: \n';
                    activity.childrens.forEach(child => {
                        this.form.activities[activity.number] = this.form.activities[activity.number] + activity.number + '.' + child.number + ' - ' + child.title + '\n';
                    })
                    this.form.activities[activity.number] = this.form.activities[activity.number] + '\nDESCRIEREA ACTIVITĂȚII:\n';
                })
            }
        }
    }
</script>

<style scoped>
.subtitle{
  font-weight: bold;
}
</style>
